import React from "react";
import { Marker } from "@react-google-maps/api";
import { Map } from "./Map";

const mapOptions = { mapTypeControl: false };

export const MapPreview = ({ selectedPosition, previewContainerStyle }) => {
  return (
    <Map
      mapContainerClassName={previewContainerStyle}
      options={mapOptions}
      zoom={15}
      center={selectedPosition}
    >
      <Marker position={{ lat: selectedPosition.lat, lng: selectedPosition.lng }} />
    </Map>
  );
};
